import { NOTE_TYPE, Note } from "../../../../components/note/note";

const InventoryTrackingConnectionNote: React.FC = () => {
    let note = `To update this WMS/3PL about returned items, make sure to adjust your <a href="%s" target="_blank">Return Methods</a> accordingly.`;

    return (
        <Note
            type={NOTE_TYPE.INFORMATION}
            body={<div dangerouslySetInnerHTML={{ __html: note.replace('%s', 'https://app.returngo.ai/dashboard/settings/return-methods') }} />}
        />
    );
}

export default InventoryTrackingConnectionNote;